// src/utils/ConjuntoGeraQtdUtils.js
const numero = (valor) => Number(valor || 0);

export const criarMapaSelecoesConjuntos = (conjuntos = []) => conjuntos.reduce((mapa, vinculo) => {
  mapa[vinculo.conjuntoId ?? vinculo.conjunto?.id] = {};
  return mapa;
}, {});

export const obterIdsConjuntosGeradores = (conjuntos = []) => new Set(
  conjuntos
    .filter(vinculo => vinculo?.conjunto?.conjuntoGeraQtd === true)
    .map(vinculo => Number(vinculo.conjuntoId ?? vinculo.conjunto?.id))
);

export const obterIdsConjuntosDefinidores = (conjuntos = []) => new Set(
  conjuntos
    .filter(vinculo => vinculo?.conjunto?.defineValorItem === true)
    .map(vinculo => Number(vinculo.conjuntoId ?? vinculo.conjunto?.id))
);

export const calcularQuantidadeGerada = (conjuntos = [], selecoes = {}) => {
  const idsGeradores = obterIdsConjuntosGeradores(conjuntos);

  return Object.entries(selecoes).reduce((total, [conjuntoId, itens]) => {
    if (!idsGeradores.has(Number(conjuntoId))) return total;
    return total + Object.values(itens || {}).reduce(
      (subtotal, item) => subtotal + numero(item?.qtdSel),
      0
    );
  }, 0);
};

export const calcularResumoItemDelivery = ({
  produto,
  conjuntos = [],
  selecoes = {},
  adicionais = [],
  quantidadeManual = 1,
  valorApresentacao = 0
}) => {
  const idsDefinidores = obterIdsConjuntosDefinidores(conjuntos);
  const quantidadeAutomatica = obterIdsConjuntosGeradores(conjuntos).size > 0;
  const valorDefinidoPorConjunto = idsDefinidores.size > 0;
  const quantidade = quantidadeAutomatica
    ? calcularQuantidadeGerada(conjuntos, selecoes)
    : Math.max(1, numero(quantidadeManual));
  let valorUnitario = numero(produto?.preco);
  const valorConjuntos = Object.entries(selecoes).reduce((total, [conjuntoId, itens]) => {
    if (valorDefinidoPorConjunto && idsDefinidores.has(Number(conjuntoId))) {
      Object.values(itens || {}).forEach(item => {
        if (numero(item?.qtdSel) > 0) valorUnitario = Math.max(valorUnitario, numero(item?.valorAdicional));
      });
      return total;
    }

    return total + Object.values(itens || {}).reduce(
      (subtotal, item) => subtotal + numero(item?.valorAdicional) * numero(item?.qtdSel),
      0
    );
  }, 0);
  if (!valorDefinidoPorConjunto && quantidadeAutomatica) valorUnitario = 0;
  const valorItem = valorUnitario * quantidade;
  const valorAdicional = valorConjuntos + (
    numero(valorApresentacao) + adicionais.reduce((total, adicional) => total + numero(adicional?.preco), 0)
  ) * quantidade;

  return {
    quantidadeAutomatica,
    quantidade,
    valorUnitario,
    valorItem,
    valorAdicional,
    valorTotal: valorItem + valorAdicional,
    total: valorItem + valorAdicional
  };
};

export const obterMultiplicadorLimiteConjunto = ({
  conjunto,
  quantidade,
  quantidadeAutomatica
}) => {
  if (!quantidadeAutomatica) return quantidade;
  if (conjunto?.conjuntoGeraQtd === true) return 1;
  return Math.max(quantidade, 1);
};
